import { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

function MainLayout() {

  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={`crm-container ${collapsed ? "collapsed-layout" : ""}`}>

      {/* SIDEBAR */}
      <Sidebar collapsed={collapsed} />

      {/* MAIN */}
      <div className="main-content">

        


        {/* NAVBAR */}
        <Navbar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        {/* 🔥 PAGE CONTENT */}
        <div className="page-content">
          <Outlet />
        </div>


      </div>

    </div>
  );
}

export default MainLayout;